module.exports = __webpack_public_path__ + "static/media/Timeline-1.03ede0c8.svg";